jQuery(document).ready(function(jQuery) {
  /*################### Home Pages ######################*/
  /* Sticky Header */
  function sticky_section() {
    var header_h = jQuery('.site-header').height();
    jQuery(window).scroll(function(){
      var sticky = jQuery('.site-header'),
          scroll = jQuery(window).scrollTop();
      if (scroll >= 1){
        sticky.addClass('fixed');
        jQuery('body').addClass('fixed');
        jQuery('body').css('padding-top', header_h);
        jQuery('.announcement-bar').hide();
      }
      else {
        sticky.removeClass('fixed');
        jQuery('body').removeClass('fixed');
        jQuery('body').css('padding-top', '0');
        jQuery('.announcement-bar').show();
      }
    });
  }
  sticky_section();
  jQuery(window).on('load resize orientationchange', sticky_section);
  
  /* Footer */
  jQuery(".site-footer .footer-wrapper .columns_title").click(function(){
    jQuery(".footer-wrapper").toggleClass("toggle-height");
    jQuery(".copyright").toggleClass("toggle-height");
    //jQuery(".footer-toggle").toggle();
  });
  
  jQuery(document).mouseup(function (e) {
    var footer = jQuery('.site-footer');
    if (!footer.is(e.target) && footer.has(e.target).length === 0){
      jQuery(".footer-wrapper").removeClass("toggle-height");
      jQuery(".copyright").removeClass("toggle-height");
    }
  });
    
  /* Slick Slider */
  jQuery('.slider').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: false,
        }
      }
    ]
  });

  jQuery('.js-product-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: true,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"><i class="fa fa-angle-right"></i></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  jQuery('.logo-bar').slick({
    arrows: true,
    centerPadding: "0px",
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
  jQuery('.related-article').slick({
    arrows: true,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  function container_section() {
    var full_width = jQuery('body').width();
    var container = jQuery('.navigation-logo .container').width();
    var temp_padding = full_width - container;
    var final_padding = temp_padding / 2;
    jQuery(".newsletter-section .newsletter-form").css('padding-right', final_padding);
  }
  container_section();
  jQuery(window).on('load resize orientationchange', container_section);

  /* Scroll Button */
  jQuery(document).on('click', '.scroll-btn, .review-scroll', function(event) {
    var jQueryanchor = jQuery(this);
    jQuery('html, body').stop().animate({
      scrollTop: jQuery(jQueryanchor.attr('href')).offset().top
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });
  
  /*################### Inner Pages ######################*/
  /* Accordion */ 
  $(".accordion-content").hide(); 
  $(".accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.accordion-content').slideUp();
      $('.accordion-title').not(this).removeClass('active');
      $('.accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /* Product Page Accordion */ 
  $(".p-accordion-content:not(.description)").hide(); 
  $(".p-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.p-accordion-content').slideUp();
      $('.p-accordion-title').not(this).removeClass('active');
      $('.p-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.p-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.p-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });
  
  var init = {      
      cssEase: "linear",
      dots: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      infinite: true,
      autoplaySpeed: 6000,
      vertical: true,
      prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"/></svg></button>',
      responsive: [
      {
        breakpoint: 1439, 
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1365, 
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1023, 
        settings: {
          slidesToShow: 6,
          vertical: true,
        }
      },
      {
        breakpoint: 750, 
        settings: {
          vertical: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg></button>',
        }
      },
      {
        breakpoint: 420, 
        settings: {
          vertical: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg></button>',
        }
      }
    ]
  };
  
  $(function () {
    var win = $(window);
    var slider = $(".product-single__thumbnails-slider-track");
  
    win.on("load resize orientationchange", function () {
      if (win.width() >= 320) {        
        slider.not(".slick-initialized").slick(init);
      } else if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");        
      }
    });
  });

  /* footer accordion */   
  var acc = document.getElementsByClassName("mobile-accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
  
  /* Brand Filter */
  var triggers = $('.brand-filter a');
  var filters = $('.brand-list .brand-item .brand-title');
  triggers.click(function() {
    $(".all-link").removeClass('active');
    var takeLetter = $(this).text(), result = 0;
    filters.parent().hide();
    triggers.removeClass('active');
    $(this).addClass('active');
    $('#result').show();
    filters.each(function(i) {
      if ( RegExp('^'+takeLetter).test($(this).text()) ) {
        result += 1;
        $(this).parent().fadeIn(222);
      } 
    });
    $('#result').html('<p>'+(result<1 ? 'Brands not avaliable.' : result+' Brands avaliable')+'</p>');
    //if (result<1) {alert('There is no result.');}
  });

  $(".brand-filter .all-link").click(function(){
    $(this).addClass('active');
    filters.parent().show();
    triggers.removeClass('active');
    $('#result').hide();
  });

  $(".read-more-trigger").click(function(){
    $(".c-toggle-content").addClass('active');
    $(this).hide();
  });

  $(".read-less-trigger").click(function(){
    $(".c-toggle-content").removeClass('active');
    $(".read-more-trigger").show();
  });

  /* Bottom Top */
  if (jQuery('#back-to-top').length) {
    var scrollTrigger = 100, // px
    backToTop = function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > scrollTrigger) {
            jQuery('#back-to-top').addClass('show');
        } else {
            jQuery('#back-to-top').removeClass('show');
        }
    };
    backToTop();
    jQuery(window).on('scroll', function () {
      backToTop();
    });
    jQuery('#back-to-top').on('click', function (e) {
      e.preventDefault();
      jQuery('html,body').animate({
          scrollTop: 0
      }, 700);
    });
  }
  
  /*################### Cart Pages ######################*/
  jQuery(".gift-textarea").hide();
  
  if($("#gift-wrapping").prop('checked') == true){
    jQuery(".gift-textarea").show();
  }
 
  /*setTimeout(function(){
    jQuery('.site-header .navigation-logo .menu-nav ul#SiteNav li[itemid="15tyD"] .mm-submenu .mm-submenu li a[aria-label="Seasonal reduction"]').attr("data-fancybox");
    jQuery('.site-header .navigation-logo .menu-nav ul#SiteNav li[itemid="15tyD"] .mm-submenu .mm-submenu li a[aria-label="Seasonal reduction"]').attr("data-src","#lingerie-fitting-popup");
    //jQuery('a[data-src="#lingerie-fitting-popup"]').trigger('click');
  }, 3000);
  */
  /*################### Megamenu Hover ######################*/
  /*  setTimeout(function(){
    jQuery(".site-header .navigation-logo .menu-nav ul#SiteNav li[itemid=ytoAg] ul.mm-submenu.tabbed li .mm-submenu li[submenu-columns='1'] .mm-submenu  li a[aria-label='Bras']").click(function(){
      jQuery(this).toggleClass('active-link');
      jQuery(".site-header .navigation-logo .menu-nav ul#SiteNav li[itemid=ytoAg] ul.mm-submenu.tabbed li .mm-submenu li[submenu-columns='1']:nth-child(2)").toggleClass("active-menu");
    });
  }, 3000);
  */
  
  /*################### Size chart Popup ######################*/
  /*var size_chart = jQuery("label[for='pa_Size']").text();
  jQuery("label[for='pa_Size']").parent(".swatch--gl").addClass('size_option');
  if(jQuery(".globo-swatch-product-detail .swatch--gl.size_option label").attr("for", "pa_Size")){
    setTimeout(function(){
      $(".size-chart-container").insertAfter(".globo-swatch-product-detail .swatch--gl.size_option .value li:last-child");
    }, 500);  
  }*/
  
  /*var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }*/
});